<div class="navblock hidden-print">
  <button *ngIf="canAddReportTemplate()" (click)="openCreateModal()" class="btnadd">{{'Add report template'|translate}}</button>
  <div class="inputgroup">
    <input class="searchinput" type="text" placeholder="{{'Find by name' | translate }}" [(ngModel)]="nameFilter"
           (input)="onTermChange($event)" />
  </div>
  <div class="inputgroup">
    <select [(ngModel)]="containerFilterId">
      <option [ngValue]="0">{{'-'|translate}}</option>
      <option *ngFor="let container of containers" [ngValue]="container.Id">{{container.Name}}</option>
    </select>
  </div>
</div>
<div class="tablewrap admindrivers">
  <div class="table">
    <table fixedcols="[0, 2]" id="exporttable">
      <tr>
        <th>
            <switch-all-checkbox [items]="filteredReports" />
        </th>
        <th>{{'Name' | translate}}</th>
        <th>{{'Container' | translate}}</th>
        <th>{{'Type' | translate}}</th>
        <th>&nbsp;</th>
      </tr>
      <tr *ngFor="let report of filteredReports | pagesfilter: pageInfoFilter">
        <td>
          <input type="checkbox" [(ngModel)]="report.IsChecked"/>
        </td>
        <td>{{report.Name}}</td>
        <td>{{getContainerName(report.ContainerId)}}</td>
        <td>{{reportTypes.get(report.Type) | translate}}</td>
        <td class="hidden-print">
          <button *ngIf="canEditReportTemplate(report)" class="btn_img btn_edit"  title="{{'Edit'|translate}}" (click)="onEditReportTemplate(report, $event)"></button>
          <button *ngIf="canDeleteReportTemplate(report)" class="btn_img btn_trush " (click)="onDeleteReportTemplate(report, $event)" title="{{'Delete'|translate}}"></button>
        </td>
      </tr>
    </table>
  </div>
</div>
<app-footer-component (onDeleteSelected)="deleteSelected()" [viewMode]="'print excel pages'"
                      (onPageChange)="onPageChange($event)"
                      [items]="filteredReports"></app-footer-component>

<template #mgmtDialog></template>
